import { render, staticRenderFns } from "./ClinicBankOrders.vue?vue&type=template&id=8b7bf668"
import script from "./ClinicBankOrders.vue?vue&type=script&lang=js"
export * from "./ClinicBankOrders.vue?vue&type=script&lang=js"
import style0 from "./ClinicBankOrders.vue?vue&type=style&index=0&id=8b7bf668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports